import { MapPin } from 'lucide-react'
import { countryFlagClass } from '../../lib/country-flags'

interface GeoCountry {
  country: string
  sessions: number
  desktopPercent: number
  mobilePercent: number
  sharePercent: number
}

interface GeoDistributionProps {
  countries: GeoCountry[]
}

function CountryFlag({ country }: { country: string }) {
  const cls = countryFlagClass(country)
  if (cls) {
    return <span className={`${cls} text-base`} />
  }
  return <MapPin className="w-3.5 h-3.5 text-[#555A73]" strokeWidth={1.25} />
}

export function GeoDistribution({ countries }: GeoDistributionProps) {
  return (
    <div>
      <h3 className="text-sm font-semibold text-[#1B2559] mb-3">
        R&eacute;partition g&eacute;ographique
      </h3>

      <div className="bg-white border border-[#E2E4ED] rounded-xl overflow-hidden">
        {countries.length === 0 ? (
          <div className="px-5 py-10 text-center text-sm text-[#8B8FA7]">
            Aucune donn&eacute;e disponible
          </div>
        ) : (
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-[#E2E4ED]">
                <th className="text-left px-5 py-3 text-[#555A73] font-medium">Pays</th>
                <th className="text-left px-5 py-3 text-[#555A73] font-medium">Part</th>
                <th className="text-left px-5 py-3 text-[#555A73] font-medium">Sessions</th>
                <th className="text-left px-5 py-3 text-[#555A73] font-medium">Desktop</th>
                <th className="text-left px-5 py-3 text-[#555A73] font-medium">Mobile</th>
              </tr>
            </thead>
            <tbody>
              {countries.map((entry) => (
                <tr
                  key={entry.country}
                  className="border-b border-[#E2E4ED] last:border-0 hover:bg-[#F4F5FA] transition-colors"
                >
                  <td className="px-5 py-3">
                    <div className="flex items-center gap-2">
                      <CountryFlag country={entry.country} />
                      <span className="text-[#1B2559]">{entry.country}</span>
                    </div>
                  </td>
                  <td className="px-5 py-3">
                    <div className="flex items-center gap-2">
                      <div className="w-16 h-1.5 bg-[#F4F5FA] rounded-full overflow-hidden">
                        <div
                          className="h-full bg-amber-400 rounded-full"
                          style={{ width: `${Math.min(entry.sharePercent, 100)}%` }}
                        />
                      </div>
                      <span className="font-mono text-[#8B8FA7]">
                        {entry.sharePercent.toFixed(1)}%
                      </span>
                    </div>
                  </td>
                  <td className="px-5 py-3 font-mono text-[#8B8FA7]">
                    {entry.sessions.toLocaleString('fr-FR')}
                  </td>
                  <td className="px-5 py-3 font-mono text-[#8B8FA7]">
                    {entry.desktopPercent.toFixed(1)}%
                  </td>
                  <td className="px-5 py-3 font-mono text-[#8B8FA7]">
                    {entry.mobilePercent.toFixed(1)}%
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  )
}
